import React, { useState, useEffect } from 'react'; // Import useState and useEffect
import './WebTopic.css';
import MultiGallery from './MultiGallery.js';
import WebApps from './WebApps.js';
import CustomButton from './CustomButton.js';

// Importa le immagini locali. Assicurati che questi percorsi siano corretti
// e che i file immagine esistano nella tua cartella 'src/img'.
import inkfactImage from './img/websites/jpg/inkfact-01.jpg';
import aloImage from './img/websites/jpg/alo-02.jpg';
import welchomeImage from './img/websites/jpg/welchome-01.jpg';
import acusmagicImage from './img/websites/jpg/acusmagic-01.jpg';
import trefoloniImage from './img/websites/jpg/trefoloni-01.jpg';
import innovartImage from './img/websites/jpg/innovart-01.jpg';
import visitAuvergneImage from './img/websites/jpg/visitAuvergne-01.jpg';
import zapDesignImage from './img/websites/jpg/zapDesign-01.jpg';


const items = [
  {
    type: 'image',
    title: 'InkfactTattoo',
    description: 'Tattoo parlour',
    linkClass: 'website-screenshot',
    content: inkfactImage, // Usa l'immagine importata
    extras: {
      title: 'Go to website',
      url: 'https://inkfacttattoo.com/'
    },
  },
  {
    type: 'image',
    title: 'Alo',
    description: 'artist',
    linkClass: 'website-screenshot',
    content: aloImage, // Usa l'immagine importata
    extras: {
      title: 'Go to website',
      url: 'https://aloartist.studio/'
    },
  },
  {
    type: 'image',
    title: 'Welchome',
    description: 'Real estate',
    linkClass: 'website-screenshot',
    content: welchomeImage, // Usa l'immagine importata
    extras: {
      title: 'Go to website',
      url: 'https://welchome.net/'
    },
  },
  {
    type: 'image',
    title: 'AcusMagic',
    description: 'Audio software house',
    linkClass: 'website-screenshot',
    content: acusmagicImage, // Usa l'immagine importata
    extras: {
      title: 'Go to website',
      url: 'https://acusmagic.com/'
    },
  },
  {
    type: 'image',
    title: 'Trefoloni e associati',
    description: 'Communication agency',
    linkClass: 'website-screenshot',
    content: trefoloniImage, // Usa l'immagine importata
    extras: {
      title: 'Go to website',
      url: 'https://www.trefolonieassociati.com/'
    },
  },
  {
    type: 'image',
    title: 'Innovart',
    description: 'Art & NFT',
    linkClass: 'website-screenshot',
    content: innovartImage, // Usa l'immagine importata
    extras: {
      title: 'Go to website',
      url: 'https://www.innovart.io/'
    },
  },
  {
    type: 'image',
    title: 'VisitAuvergne',
    description: 'Tourism and Culture',
    linkClass: 'website-screenshot',
    content: visitAuvergneImage, // Usa l'immagine importata
    extras: {
      title: 'Go to website',
      url: 'https://visitauvergne.org/'
    },
  },
    {
    type: 'image',
    title: 'ZapDesign',
    description: 'Portfolio \n This very website !',
    linkClass: 'website-screenshot',
    content: zapDesignImage, // Usa l'immagine importata
    extras: {
      title: 'React + NodeJS',
      url: 'https://zapdesign.top/'
    },
  },
];

const config = {
  showNavigationArrows: false, // You explicitly want to turn this off
  overlayColor: 'rgba(0, 0, 0, 0.8)'
};


function WebTopic({ 
  acceptedCookieCategories = { essential: true, analytics: false, marketing: false, externalMedia: false },
  onUpdateCookiePreferences = () => {} 
 }) {
    // State to hold the responsive scrollMarginTop value
    const [responsiveScrollMargin, setResponsiveScrollMargin] = useState('0rem'); // Initialize with a default or mobile value

    // Effect to determine and update scrollMarginTop based on screen width
    useEffect(() => {
        const updateScrollMargin = () => {
            // Define your desktop and mobile breakpoints and corresponding margins
            const desktopWidth = 768; // Standard breakpoint for md: in Tailwind
            const desktopMargin = '-92rem'; // Your desired desktop offset
            const mobileMargin = '2rem';   // Your desired mobile offset

            if (window.innerWidth >= desktopWidth) {
                setResponsiveScrollMargin(desktopMargin);
            } else {
                setResponsiveScrollMargin(mobileMargin);
            }
        };

        // Set initial margin on mount
        updateScrollMargin();

        // Add event listener for window resize
        window.addEventListener('resize', updateScrollMargin);

        // Clean up event listener on component unmount
        return () => window.removeEventListener('resize', updateScrollMargin);
    }, []); // Empty dependency array means this effect runs once on mount and cleans up on unmount

    // Generic function for smoothly scrolling to any target element ID
    const handleSmoothScroll = (targetId) => {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            console.warn(`Target element with ID '${targetId}' not found for smooth scroll.`);
        }
    };

    return (
        <div id="web-topic-container">
            <div id="description-container">
                <span className="title"></span>
                <span className="content">
                    Designing websites and web applications. <br/>
                    <span className="content-small">React | Wordpress | Javascript | CSS | HTML | PHP | Python</span>
                </span>
            </div>
            
            <CustomButton onClick={() => handleSmoothScroll('web-apps-section-web-topic')}>
                Go to Web Applications
            </CustomButton>
            
            <MultiGallery
                items={items} 
                acceptedCookieCategories={acceptedCookieCategories} 
                onUpdateCookiePreferences={onUpdateCookiePreferences} 
            />
            
            {/*
                This is the target div for the smooth scroll in WebTopic.
                Using a unique ID to avoid conflicts if CodingTopic also has a 'web-apps' ID.
                The scrollMarginTop style is dynamically set based on screen width.
            */}
            <div id="web-apps-section-web-topic" style={{ scrollMarginTop: responsiveScrollMargin }}>
                <WebApps 
                acceptedCookieCategories={acceptedCookieCategories} 
                onUpdateCookiePreferences={onUpdateCookiePreferences}
                />
            </div>
        </div>
    );
}

export default WebTopic;
